import { Component, OnInit, NgZone } from '@angular/core';
import { ModulemappingService } from 'src/app/erp/services/modulemapping/modulemapping.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login/login.service';
import { StockReportsService } from 'src/app/erp/services/reports/stockreports/stockreports.service';
import { saveAs } from 'file-saver';
import * as localForage from 'localforage';
import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2';
 
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms ease-in-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class HomeComponent implements OnInit {
  public moduleList: any[] = [];
  // public user: any = {};
  public user: any = null;
  public itemList: any[] = [];
  public itemsData: any[] = [];
  // public module: any = {};
  public module: any = null;
 
  updateMessages: string[] = [
    '15 new features updated successfully.',
    'The media folder is created successfully.',
    '12 emails from David Michaiah.',
    'Server maintenance scheduled for tonight.',
    'New user registrations increased by 30%.'
  ];
  currentMessage: string = this.updateMessages[0]; // Start with the first message
  private index: number = 0;
 
  constructor(
    private moduleMappingService: ModulemappingService,
    private router: Router,
    private loginService: LoginService,
    private stockReportService: StockReportsService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone // Added NgZone for running timers in Angular's zone
  ) {}
 
  ngOnInit() {
    this.getModules();
    this.getItemsData();
    this.startMessageRotation();
    // this.hrmsLogin(); 
  }

//   hrmsLogin() {
//     const userData = this.loginService.getUser();

//     if (!userData || typeof userData !== 'object') {
//         console.error('userData is invalid or empty:', userData);
//         Swal.fire({
//             icon: 'error',
//             title: 'Invalid User Data',
//             text: 'User data is missing or not an object.'
//         });
//         return;
//     }

//     const payload = {
//         employeeCode: userData.EmployeeCode || userData.employeeCode || 'adminl1',
//         password: userData.Password || userData.password || 'test',
//         locationId: userData.LocationID != null ? Number(userData.LocationID) : (userData.locationId != null ? Number(userData.locationId) : 1),
//         yearNo: userData.YearNo != null ? Number(userData.YearNo) : (userData.yearNo != null ? Number(userData.yearNo) : 7)
//     };

//     if (!payload.employeeCode || !payload.password || payload.locationId == null || payload.yearNo == null) {
//         console.error('Missing fields in payload:', payload);
//         Swal.fire({
//             icon: 'error',
//             title: 'Missing Fields',
//             text: 'Required fields (employeeCode, password, locationId, yearNo) are missing or invalid.'
//         });
//         return;
//     }

//     this.loginService.hrmslogin(payload).subscribe({
//         next: (res) => {
//             if (res.status === 200) {
//                 const user = res.body;
//                 this.loginService.storeHrmsData(user);
//             } else {
//                 console.error('Login failed with status:', res.status);
//                 Swal.fire('HRMS Login Fail.', 'Please check api endpoint', 'error');
//             }
//         },
//         error: (error) => {
//             console.error('HRMS login error:', {
//                 status: error.status,
//                 statusText: error.statusText,
//                 message: error.message,
//                 headers: error.headers,
//                 url: error.url,
//                 response: error.error
//             });
//             Swal.fire({
//                 icon: 'error',
//                 title: 'Error',
//                 text: `Failed to connect to HRMS API: ${error.status} ${error.statusText}`
//             });
//         }
//     });
// }

  updateMessage(newMessage: string) {
    this.currentMessage = newMessage;
    this.cdr.detectChanges(); 
  }
 

  startMessageRotation() {
    this.zone.run(() => { 
      setInterval(() => {
        this.index = (this.index + 1) % this.updateMessages.length; 
        this.updateMessage(this.updateMessages[this.index]); 
      }, 7000); 
    });
  }
 
  async getItemsData() {
    this.user = this.loginService.getUser();
    let itemdata;
    try {
      await localForage.clear();
      itemdata = await localForage.getItem('itemsData');
    } catch (err) {
      console.log(err);
    }
    if (itemdata == null || itemdata == undefined) {
      this.stockReportService.getActiveItems(this.user.LocationID).subscribe(result => {
        if (result.length > 0) {
          this.itemList = [];
          let resData = {};
          result.forEach(item => {
            resData = {
              ID: item.ItemID,
              Code: item.ItemName
            };
            this.itemList.push(resData);
          });
          this.itemsData = this.itemList;
        }
        localForage.setItem('itemsData', this.itemsData);
      });
    }
  }
 
  saveItemsData() {
    const blob = new Blob([JSON.stringify(this.itemsData)], { type: 'application/json' });
    saveAs(blob, 'items-list.json');
  }
 
  modules = [
    { ModuleFilePath: 'Admin.png', ModuleName: 'Admin', ModulePath: '/admin', Description: 'Manage admin users and permissions' },
    { ModuleFilePath: 'Sales.png', ModuleName: 'Sales & Distribution', ModulePath: '/erp/sales/sales-dashboard', Description: 'Handle sales and distribution operations' },
    { ModuleFilePath: 'Accounts.png', ModuleName: 'Accounts', ModulePath: '/accounts', Description: 'Manage company financials' },
    { ModuleFilePath: 'Hrms.png', ModuleName: 'HRMS', ModulePath: '/hrms', Description: 'Human Resource Management System' },
    { ModuleFilePath: 'Analitics.png', ModuleName: 'Analytics', ModulePath: '/analytics', Description: 'Analyze business with reports' },
    { ModuleFilePath: 'Business.png', ModuleName: 'Business', ModulePath: '/business', Description: 'Manage business process & workflows' },
    { ModuleFilePath: 'Service.png', ModuleName: 'Service', ModulePath: '/service', Description: 'Customer service management' },
    { ModuleFilePath: 'Service.png', ModuleName: 'Casa-Notificaions', ModulePath: '/casa-notifications', Description: 'Casa Notifications' },
];
 
showAlert(): void {
  Swal.fire({
    title: 'Alert',
    text: 'For this page, please contact the admin for the OTPs and provide the OTP URL to the admin.',
    icon: 'info',
    confirmButtonText: 'OK'
  });
}
 
  // getModules() {
  //   this.moduleMappingService.getModules().subscribe(res => {
  //     this.moduleList = [];
  //     if (res.body.length > 0) {
  //       res.body.map(menu => {
  //         const matchedModule = this.modules.find(m => m.ModuleName.trim() === menu.ModuleName.trim());
  //         if (matchedModule) {
  //           menu.ModuleFilePath = matchedModule.ModuleFilePath;
  //           menu.path = matchedModule.ModulePath;
  //           menu.Description = matchedModule.Description;
  //         } else {
  //           menu.ModuleFilePath = 'default.png';
  //           menu.path = '/default/dashboard/' + menu.ModuleID;
  //           menu.Description = 'No description available';
  //         }
  //       });
  //     }
  //     console.log('Final moduleList:', this.moduleList);
  //     this.moduleList = res.body;
  //   });
  // }
  getModules() {
    this.user = this.loginService.getUser();
    const hrmsEnabled = Array.isArray(this.user?.Configuration) &&
      this.user.Configuration.some((c: any) => c.KeyName === 'HRMSEnabled' && c.KeyValue === 'Y');
  
    this.moduleMappingService.getModules().subscribe(res => {
      this.moduleList = [];
      if (res.body.length > 0) {
        const filteredModules = res.body.filter(menu => {
          if (menu.ModuleName && menu.ModuleName.trim() === 'HRMS') {
            return hrmsEnabled; // Only include if enabled
          }
          return true; 
        });
  
        filteredModules.map(menu => {
          const matchedModule = this.modules.find(m => m.ModuleName.trim() === menu.ModuleName.trim());
          if (matchedModule) {
            menu.ModuleFilePath = matchedModule.ModuleFilePath;
            menu.path = matchedModule.ModulePath;
            menu.Description = matchedModule.Description;
          } else {
            menu.ModuleFilePath = 'default.png';
            menu.path = '/default/dashboard/' + menu.ModuleID;
            menu.Description = 'No description available';
          }
          this.moduleList.push(menu);
        });
      }
    });
  }
  updateModuleId(moduleId: any) {
    localStorage.setItem('moduleId', moduleId);
  }
}